import { Box, Stack, Typography, Link as MuiLink, styled } from '@mui/material';
import Link from 'next/link';
import PlanCardButton from '../buttons/PlanCardButton';
import { BsGift } from 'react-icons/bs';

const Flag = styled(Box)(({ theme }) => ({
  width: 70,
  minHeight: 110,
  boxSizing: 'content-box',
  position: 'relative',
  background: theme.palette.primary.main,

  '&:after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: 0,
    height: 0,
    borderBottom: '13px solid #fff',
    borderLeft: '35px solid transparent',
    borderRight: '35px solid transparent',
  },
}));

const PlanCard = ({
  plan,
  recommended = false,
  features = [],
  discount = 0,
  activeGift = false,
}) => {
  return (
    <>
      <Box
        sx={{
          position: 'relative',
          width: '340px',
          minWidth: '250px',
          height: recommended ? '600px' : '500px',
        }}>
        <Box
          sx={{
            bgcolor: 'common.white',
            minHeight: recommended ? '550px' : '450px',
            borderRadius: 3,
            px: 2,
            py: 4,
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
            boxShadow: 5,
          }}>
          <Typography
            color="grey.500"
            fontSize={24}
            fontWeight={500}
            sx={{ textAlign: 'center' }}>
            {plan.planType?.title}
          </Typography>
          <Stack
            sx={{ justifyContent: 'center', alignItems: 'center', gap: 2 }}>
            {features.map((item, index) => (
              <Typography key={index} textAlign="center">
                {item}
              </Typography>
            ))}
          </Stack>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            mx: 'auto',
            display: 'flex',
            justifyContent: 'center',
          }}>
          <MuiLink
            component={Link}
            href={`/subscription?plan=${plan.planType?.value}`}
            variant="simpleLink">
            <PlanCardButton
              finalPrice={
                plan.finalPrice - discount > 0 ? plan.finalPrice - discount : 0
              }
              recommended={recommended}
            />
          </MuiLink>
        </Box>
        {activeGift && (
          <Box
            sx={{
              position: 'absolute',
              right: 10,
              top: 0,
            }}>
            <Flag>
              <Stack
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 0.5,
                  gap: 1,
                  height: 90,
                }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography fontWeight={700}>
                    14<small>روز</small>
                  </Typography>
                  <Typography fontWeight={700}>رایگان</Typography>
                </Box>
                <BsGift size={30} color="#fff" name="ساخت دوره آموزشی" />
              </Stack>
            </Flag>
          </Box>
        )}
      </Box>
    </>
  );
};

export default PlanCard;
